import { useNavigate } from 'react-router-dom';
import type { ListData } from '../../../types';
import useToast from '../contexts/useToast';

type Props = {
  item: ListData;
};

const DeleteButton = ({ item }: Props) => {
  const { showToast } = useToast();
  const navigate = useNavigate();

  const handleDeleteContent = async () => {
    const confirmed = window.confirm(
      'Are you sure you want to delete this content? This will remove all user data, audio files, and cannot be undone.'
    );
    if (!confirmed) return;

    try {
      const res = await fetch('/api/content/delete', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ contentId: item.id }),
      });
      if (!res.ok) {
        showToast('Failed to delete content.', 'error');
        return;
      }
      showToast('Content deleted successfully.', 'success');
      navigate(-1);
    } catch (err) {
      console.error('Failed to delete content', err);
      showToast('Failed to delete content.', 'error');
    }
  };

  return (
    <button
      className="pill-button"
      onClick={handleDeleteContent}
      title="Delete content"
    >
      Delete
    </button>
  );
};

export default DeleteButton;
